'use client';
import { SeriesSelectionBlock } from '~/app/_components/series-selection-block';
import { useLocalHooks } from './use-local-hooks';

type Props = {
  ngKeywords: string[];
};

export const MeRecommendedSeriesBlock = ({ ngKeywords }: Props) => {
  const { series, showLoading, showSensitive } = useLocalHooks({ ngKeywords });

  return (
    <SeriesSelectionBlock
      title="あなたにおすすめ"
      series={series ?? []}
      showLoading={showLoading}
      showSensitive={showSensitive}
    />
  );
};
